import { CloseCircleOutlined } from "@ant-design/icons";
import { Popover } from "antd";
import type { PopoverProps } from "antd";
import { useCallback, useMemo, useRef, useState } from "react";
import { useTheme } from "styled-components";

import { Stack } from "core/components/Stack";
import { WithTooltip } from "core/components/WithTooltip";
import localStorage from "legacy/utils/localStorage";
import { STORAGE_KEYS } from "legacy/utils/StorageUtils";

export const IntercomPopover = (props: PopoverProps) => {
  const theme = useTheme();
  const [hasDismissed, setHasDismissed] = useState(
    !!localStorage.getItem(STORAGE_KEYS.SHOW_INTERCOM_POPOVER_KEY),
  );

  const chatPrompt = "Chat with a Superblocks Engineer";

  const onDismiss = useCallback(() => {
    localStorage.setItem(STORAGE_KEYS.SHOW_INTERCOM_POPOVER_KEY, "true");
    setHasDismissed(true);
  }, []);

  const content = useMemo(
    () => (
      <Stack align="center">
        <span>{chatPrompt}</span>
        <CloseCircleOutlined
          style={{ cursor: "pointer", color: theme.colors.GREY_300 }}
          onClick={onDismiss}
        />
      </Stack>
    ),
    [onDismiss, theme.colors.GREY_300],
  );
  const popoverRef = useRef<any>();

  return (
    <Popover
      content={content}
      placement="right"
      open={!hasDismissed}
      ref={(el) => {
        popoverRef.current = el;
      }}
    >
      {hasDismissed ? (
        <WithTooltip content={chatPrompt} side="right">
          {props.children}
        </WithTooltip>
      ) : (
        props.children
      )}
    </Popover>
  );
};
